export default __webpack_public_path__ + "static/media/500_1 1.b5ad93b0.svg";